<template>
  <div id="app">
    <div class="wrapper">
      <div class="header">
        <div class="logo">
          <img src="./assets/img/wp_logo.jpg" alt="" />
        </div>

        <el-menu class="header-menu" :default-active="activeIndex" mode="horizontal" @select="handleSelect"
          active-text-color="#d40c19">
          <el-menu-item index="main">关于伟普</el-menu-item>
          <el-menu-item index="alarm">基站隐患预警系统</el-menu-item>
          <el-menu-item index="ebms">EBMS</el-menu-item>
          <el-menu-item index="robot">巡检机器人</el-menu-item>
          <el-menu-item index="contact">联系我们</el-menu-item>
        </el-menu>
        <div class="phone">
          <img src="./assets/img/phone.png" alt="" />
          <span>电话：029-81565335</span>
        </div>
      </div>
      <router-view />
      <div class="footer">
        <div>
          西安市雁塔区太白南路181号西部电子社区A座A区A107-V04室　　　　电话：029-81565335
        </div>
        <div>
          <a href="http://beian.miit.gov.cn/" target="_blank">陕ICP备2020016455号-1</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      activeIndex: "",
    };
  },
  mounted() {
    this.activeIndex = this.$router.history.current.name;
  },
  methods: {
    handleSelect(tab, event) {
      this.$router.push({ path: tab });
    },
  },
};
</script>

<style lang="scss">
#app {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

body {
  font: normal 400 1rem "微软雅黑", helvetica, arial, sans-serif, simsun;
  color: #666;
  background-color: #fff;
  background: url(./assets/img/background.jpg) no-repeat scroll top center #fff;
  background-size: 100%;
}

.wrapper {
  margin: 15vh auto 0 auto;
  width: 80vw;
  border-radius: 5px 5px 0 0;
  background: #fff;

  .el-menu-item {
    font-size: 20px;
  }

  .header {
    padding: 0 3vw;
    height: 100px;
    display: flex;
    align-items: flex-end;

    .header-menu {
      margin: 0 0 0 80px;
      flex: 1;
    }

    .logo {
      width: 15vw;
      height: 100px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .phone {
      align-self: start;
      margin-top: 1vh;
      display: flex;
      align-items: center;

      img {
        width: 1.4rem;
      }

      span {
        color: #d40c19;
      }

      position: absolute;
      right: 15vw;
    }
  }

  .footer {
    font-size: 0.8rem;
    height: 10vh;
    color: #fff;
    background-color: #666;
    text-align: center;
    padding-top: 2vh;

    div,
    a {
      font-size: 1rem;
      margin-top: 1vh;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue